
  import ipxRuntime$PYH45c44efGAFEPvbkjGvXRQtgLAx_P7XgDy11oZq4w from '/builds/skuby/e-shop-template/projects/web/node_modules/.bun/@nuxt+image@2.0.0+4f84fc6d29f7a7fb/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import skubyApiRuntime$xBUdrLa_k4aGxZyif8Fg3J7_45lLQsCdB85u2QTfpXpFg from '/builds/skuby/e-shop-template/projects/web/apps/web/config/image/ApiImageProvider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "api.skuby.dev.alt-point.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$PYH45c44efGAFEPvbkjGvXRQtgLAx_P7XgDy11oZq4w, defaults: {"maxAge":604800} },
  ['skubyApi']: { setup: skubyApiRuntime$xBUdrLa_k4aGxZyif8Fg3J7_45lLQsCdB85u2QTfpXpFg, defaults: undefined }
    }
  }
